import { render } from "./trust-data-investigation-types.html?vue&type=template&id=0b2debaa&scoped=true&ts=true&external"
import script from "./trust-data-investigation-types.ts?vue&type=script&lang=ts&external"
export * from "./trust-data-investigation-types.ts?vue&type=script&lang=ts&external"

import "./trust-data-investigation-types.scss?vue&type=style&index=0&id=0b2debaa&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2debaa"]])

export default __exports__